import {Component, OnInit, EventEmitter } from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {Message} from './Message';
import {MessagesService} from './messages.service';

@Component({
    selector: 'messages',
    template: require('./messages.component.html'),
    providers: [MessagesService]
})

export class SuperUserMessagesComponent implements OnInit {

    parentMessages: Message[];                
    readMessages: Message[];
    unreadMessages: Message[];
    sendedMessages: Message[];    
    user_id: number;
    showReceivedMessages: boolean;
    showSendedMessages: boolean;
    router: Router;

    constructor(private _messagesService: MessagesService, _parentRouter: Router) {    

        this.parentMessages = [];
        this.readMessages = [];
        this.unreadMessages = [];
        this.sendedMessages = [];        
        this.user_id = -1;
        this.showReceivedMessages = true;
        this.showSendedMessages = false;
        this.router = _parentRouter;
        
    }

    ngOnInit() {

       this._messagesService.getParentMessages().then(res => {
           if (res != null) {
               this.parentMessages = res.rows;
               this.user_id = res.user_id;
               this.organizeMessages();
           }
       });

    }

    organizeMessages() {                        

        for (var i = 0; i < this.parentMessages.length; i++) {

            this._messagesService.getMessageWithChilds(this.parentMessages[i]).then(result => {
                
                var message: Message = result[0];
                message.total_messages_conversation = 1;
                message.selected = false;                
                this.setMessageDateFormat(message);
                
                //El missatge és rebut
                if (message.user_receiver_id == this.user_id) {
                    
                    if (message.childs.length == 0) {                    
                        
                        if (message.read) {
                            this.readMessages.push(message);
                        } else {
                            this.unreadMessages.push(message);
                        }

                    } else {
                                                            
                        this.organizeMessage(message);

                    }
                
                //El missatge és enviat
                } else if(message.user_sender_id == this.user_id) {                    

                    if (message.childs.length == 0) {
                        this.sendedMessages.push(message);
                    } else {
                        this.organizeMessage(message);
                    }

                }

            });

        }

    }
    
    setMessageDateFormat(message: Message) {                            

        var messageDate: Date = new Date(message.creation_date);
        var day: String = messageDate.getDate().toString();       
        if(day.length < 2) {
            day = "0" + day;
        }         
        var month: String = (messageDate.getMonth() + 1).toString();
        if(month.length < 2) {
            month = "0" + month;
        }
        var year: String = messageDate.getFullYear().toString();        
        var hour: String = messageDate.getHours().toString();
        if(hour.length < 2) {
            hour = "0" + hour;
        }
        var minute: String = messageDate.getMinutes().toString();
        if(minute.length < 2) {
            minute = "0" + minute;
        }
        var seconds: String = messageDate.getSeconds().toString();
        if(seconds.length < 2) {
            seconds = "0" + seconds;
        }                
        
        message.date_to_show = day + "/" + month + "/" + year + " - " + hour + ":" + minute + ":" + seconds;        

    }

    organizeMessage(message: Message) {

        var messagesReceived: Message[] = this.getMessagesReceivedChilds(message); 
        var messagesSended: Message[] = this.getMessagesSendedChilds(message);                
        
        message.total_messages_conversation += messagesReceived.length + messagesSended.length;

        if (messagesReceived.length == 0 && message.user_receiver_id == this.user_id) {

            if (message.read) {

                this.readMessages.push(message);

            } else {

                this.unreadMessages.push(message);

            }

        } else if (messagesReceived.length > 0) {

            this.sortArrayByMessageDate(messagesReceived);

            //Aquesta instrucció no serà necessària ja que ens encarregarem que al insertar un missatge fill nou a la base de dades automàticament tingui el title del pare
            messagesReceived[0].title = message.title;

            messagesReceived[0].total_messages_conversation = message.total_messages_conversation;

            if(message.user_sender_id == this.user_id) {

                messagesReceived[0].user_sender_name = message.user_receiver_name;

            } else if (message.user_receiver_id == this.user_id) {

                messagesReceived[0].user_sender_name = message.user_sender_name;

            }            
            
            this.setMessageDateFormat(messagesReceived[0]);

            if(messagesReceived[0].read) {
                this.readMessages.push(messagesReceived[0]);
            } else {
                this.unreadMessages.push(messagesReceived[0]);
            }

        }        

        if (messagesSended.length == 0 && message.user_sender_id == this.user_id) {

            this.sendedMessages.push(message);

        } else if (messagesSended.length > 0) {

            this.sortArrayByMessageDate(messagesSended);

            //Aquesta instrucció no serà necessària ja que ens encarregarem que al insertar un missatge fill nou a la base de dades automàticament tingui el title del pare
            messagesSended[0].title = message.title;

            messagesSended[0].total_messages_conversation = message.total_messages_conversation;            

            if(message.user_sender_id == this.user_id) {

                messagesSended[0].user_receiver_name = message.user_receiver_name;

            } else if (message.user_receiver_id == this.user_id) {

                messagesSended[0].user_receiver_name = message.user_sender_name;

            }

            this.setMessageDateFormat(messagesSended[0]);
            this.sendedMessages.push(messagesSended[0]);

        }

    }
    
    getMessagesReceivedChilds(message: Message): Message[] {

        var messageChilds: Message[] = [];
        
        for (var i = 0; i < message.childs.length; i++) {

            message.childs[i].selected = false;

            if (message.childs[i].user_receiver_id == this.user_id) {

                messageChilds.push(message.childs[i]);

            }

            if (message.childs[i].childs.length > 0) {

                messageChilds = messageChilds.concat(this.getMessagesReceivedChilds(message.childs[i]));

            }

        }
        
        return messageChilds;

    }

    getMessagesSendedChilds(message: Message): Message[] {

        var messageChilds: Message[] = [];

        for (var i = 0; i < message.childs.length; i++) {

            message.childs[i].selected = false;

            if (message.childs[i].user_sender_id == this.user_id) {

                messageChilds.push(message.childs[i]);

            }

            if (message.childs[i].childs.length > 0) {

                messageChilds = messageChilds.concat(this.getMessagesSendedChilds(message.childs[i]));

            }

        }

        return messageChilds;

    }        

    sortArrayByMessageDate(array: Message[]) {

        array.sort(function(a,b){
            return new Date(b.creation_date).getTime() - new Date(a.creation_date).getTime();        
        });

    }    

    changeToReceivedMessages() {

        this.showReceivedMessages = true;
        this.showSendedMessages = false;

    }

    changeToSendedMessages() {

        this.showReceivedMessages = false;
        this.showSendedMessages = true;

    }

    //Section 0: Read Message
    //Section 1: Unread Message
    //Section 2: Sended Message
    messageClicked(message: Message, message_section: Number) {                
        
        this.router.navigate(['/superuser', 'message', {mainId: message.main_parent_id, section: message_section}]);        

    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/messages/messages.component.ts
 **/